<template>
  <div class="container exam">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/exam/list' }">在线题库</el-breadcrumb-item>
        <el-breadcrumb-item>题库管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">题库管理</h2>
        </div>
        <div class="right">
          <el-button style="margin-left:16px;"
                     class="button"
                     type="primary"
                     @click="handleExamCreate">新建</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="题库名称"
                      prop="name">
          <el-input v-model="query.name_keyword"
                    placeholder="输入题库名称"
                    @input="fetchExamList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="关联专业"
                      prop="name">
          <el-input v-model="query.major_keyword"
                    placeholder="输入关联专业"
                    @input="fetchExamList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="关联科目"
                      prop="name">
          <el-input v-model="query.subject_keyword"
                    placeholder="输入关联科目"
                    @input="fetchExamList(true)"
                    clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="search-footer">
        <!--        <div class="filter-item">
          <span class="label">排序方式</span>
          <div class="values">
            <span
              :class="
                item.value == query.sort ? 'value-item active' : 'value-item'
              "
              v-for="item in filter.sorts"
              :key="item.value"
              @click="handleFilterChange(item.value, 'sort')"
              >{{ item.label }}</span
            >
          </div>
        </div> -->
      </div>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">题库组合列表</h3>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="query.statuses"
                            @change="fetchExamList()">
              <el-radio-button v-for="(item, index) in filter.status"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <div class="values">

        <el-table :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           width="80"
                           label="ID"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">

              {{ scope.row.id }}

            </template>
          </el-table-column>
          <el-table-column prop="name"
                           width="160"
                           label="题库名称"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="major_name"
                           label="关联专业"
                           min-width="160"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{formatMajor(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="college_code"
                           label="关联科目"
                           min-width="160"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{formatSubject(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="unlock_product_name"
                           width="250"
                           label="会员商品"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.unlock_product_name}}
            </template>
          </el-table-column>
          <el-table-column prop="count_exam"
                           width="120"
                           label="题库数量"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.count_exam}}
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="small"
                      :type="scope.row.status == 1 ? 'success' : 'danger'">{{ scope.row.status == 1 ? "上架" : "下架" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="creator_admin_nickname"
                           width="120"
                           label="创建人"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.creator_admin_nickname}}
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           align="center"
                           width="100">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="更新时间"
                           align="center"
                           width="100">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           fixed="right"
                           align="center"
                           width="200"
                           v-if="isfixed">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleExamEdit(scope.row)">编辑</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleExamChoose(scope.row)">题库</el-link>
              <el-link type="danger
            "
                       @click="handleExamRemove(scope.row.id)"
                       :underline="false">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
      <ComposeCreat :visible="createDialog"
                    @close="createDialog = false"
                    @submit="fetchExamList"></ComposeCreat>
      <ComposeEdit :visible="editDialog"
                   :content="editRow"
                   @close="editDialog = false"
                   @submit="fetchExamList"></ComposeEdit>
      <ExamBankChoosed :visible="examBankChooseDialog"
                       @close="examBankChooseDialog = false"
                       @submit="fetchExamList"
                       :editRow="this.editRow" />
    </div>
  </div>
</template>

<script>
import ComposeCreat from '@/components/dialog/examCompose/ComposeCreat.vue'
import ComposeEdit from '@/components/dialog/examCompose/ComposeEdit.vue'
import ExamBankChoosed from '@/components/dialog/examCompose/ExamBankChoosed.vue'
import {
  examComposeList,
  examComposeDestroy,
  examComposeEdit,
  examList,
} from '@/api/exam'

export default {
  components: {
    ComposeCreat,
    ComposeEdit,
    ExamBankChoosed,
  },
  data() {
    return {
      examBank: [],
      examBankChooseDialog: false,
      createDialog: false,
      editDialog: false,
      query: {
        name_keyword: '',
        subject_keyword: '',
        major_keyword: '',
        statuses: '1',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '上架', value: '1' },
          { label: '下架', value: '0' },
        ],
      },
      results: [],
      editRow: null,
      isfixed: document.body.clientWidth < 820 ? false : true,
      tabName: '',
    }
  },
  created() {
    this.fetchExamList()
  },
  methods: {
    formatMajor(val) {
      if (val.arr_major_info && val.arr_major_info.length > 0) {
        const result = val.arr_major_info
          .map((major) => {
            return `（${major.code}）${major.name}`
          })
          .join(',')
        // const codes = val.subject_codes.split(',')
        // const names = val.subject_names.split(',')
        // const result = codes
        //   .map((code, index) => {
        //     return `（${code}）${names[index]}`
        //   })
        //   .join('  ')
        return result
      } else {
        return '--'
      }
    },
    formatSubject(val) {
      if (val.arr_subject_info && val.arr_subject_info.length > 0) {
        const result = val.arr_subject_info
          .map((subject) => {
            return `（${subject.code}）${subject.name}`
          })
          .join(',')
        // const codes = val.subject_codes.split(',')
        // const names = val.subject_names.split(',')
        // const result = codes
        //   .map((code, index) => {
        //     return `（${code}）${names[index]}`
        //   })
        //   .join('  ')
        return result
      } else {
        return '--'
      }
    },
    // 题库列表请求
    fetchExamList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      examComposeList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
    },
    // 检索条件变化
    handleFilterChange(value, type) {
      if (type === 'sort') {
        this.query.sort = value
      }
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchExamList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchExamList()
    },

    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()

      setTimeout(() => {
        this.fetchExamList()
      }, 20)
    },

    // 题库删除
    handleExamRemove(examId) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          examComposeDestroy({ id: examId }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchExamList()
          })
        })
        .catch(() => {})
    },
    handleExamChoose(row) {
      this.editRow = row 
      this.examBankChooseDialog = true
    },
    handleExamEdit(row) {
      this.editRow = row
      this.editDialog = true
    },

    // 题库创建
    handleExamCreate() {
      this.createDialog = true
    },
    //题库管理
    handleExamManage() {
      this.$router.push(`/exam/manage`)
    },
  },
}
</script>

<style scoped lang="less">
.exam {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 101%;
    height: 40px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
    /deep/.el-badge__content {
      line-height: 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;
    padding-right: 32px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .exam-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    .el-link {
      margin: 0 8px;
    }
    .item-table-column {
      text-align: left;
    }
  }
}
</style>
